<script lang="ts">
  import { useKeyboardListener } from '../../hooks'
  import { togglePerspectiveCamera } from '../../stores/camera'

  $effect(() => {
    return useKeyboardListener('c', { onKeyPress: togglePerspectiveCamera })
  })
</script>
